const instruments = {
  methods: {
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;

      // Avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";
      textArea.style.width = "0px";
      textArea.style.height = "0px";
      textArea.style.overflow = "hidden";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);
        if (successful) {
          return true;
        }
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
      }

      document.body.removeChild(textArea);
    },
    copyTextToClipboard(text, successMessage = 'Успешно скопировано') {
      if (!navigator.clipboard) {
        this.$message.success(successMessage);
        return this.fallbackCopyTextToClipboard(text);
      }
      navigator.clipboard.writeText(text).then(() => {
        this.$message.success(successMessage);
        return true;
      }, function (err) {
        console.error('Async: Could not copy text: ', err);
      });
    },
    handleRequestAndNotify({ request, successMessage, errorMessage, successMethod, errorMethod }) {
      request = request || {};
      successMessage = successMessage || 'Запрос успешен';
      errorMessage = errorMessage || 'Ошибка запроса';
      if (request.success) {
        if (request.message) {
          successMessage += `: ${request.message}`;
        }
        this.$message.success(successMessage);
        if (successMethod) {
          successMethod();
        }
      } else {
        this.$message.error(`${errorMessage}: ${request.message || 'Неизвестная ошибка'}`);
        if (errorMethod) {
          errorMethod();
        }
      }
    },
    isValidURL(url) {
      try {
        // Используем конструктор URL для проверки структуры URL
        new URL(url);
        return true;
      } catch (e) {
        return false;
      }
    },
  }
};

export default instruments;
